import { Box, TableCell, Typography } from "@mui/material";
import { GetSDEnum } from "./getSDEnum";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";

export const WellProCells = ({ controller }) => {
  return (
    <>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>{controller.type}</TableCell>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>-</TableCell>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>{controller.value}</TableCell>
      {controller.value === 0 ? (
        <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: 14 }}>Normal Operation ✅</Typography>
            {/* <CheckCircleIcon sx={{ color: "success.main" }} /> */}
          </Box>
        </TableCell>
      ) : controller.value === -1 ? (
        <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: 14 }}>MODBUS ⚠️</Typography>
            {/* <WarningIcon sx={{ color: "warning.main" }} /> */}
          </Box>
        </TableCell>
      ) : controller.value > 0 ? (
        <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <GetSDEnum controller={controller} type={"WellProII"} icon={"⛔"} />
            {/* <ErrorIcon sx={{ color: "error.main" }} /> */}
          </Box>
        </TableCell>
      ) : (
        <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <GetSDEnum controller={controller} type={"WellProII"} icon={"✅"} />
            {/* <CheckCircleIcon sx={{ color: "success.main" }} /> */}
          </Box>
        </TableCell>
      )}
    </>
  );
};
